import { coerceMoneyValue } from '../common';
import { PackageStats } from './PackageStats';

export function normalizePackageStats(data: unknown): PackageStats | null {
  if (!data || typeof data !== 'object') {
    return null;
  }

  const raw = data as Record<string, unknown>;
  if (typeof raw.packageUuid !== 'string' || !raw.packageUuid) {
    return null;
  }

  const invested = coerceMoneyValue(raw.invested);
  const incomePaid = coerceMoneyValue(raw.incomePaid);
  const incomeLeft = coerceMoneyValue(raw.incomeLeft);
  const incomeTotal = coerceMoneyValue(raw.incomeTotal);
  const dividendsPaid = coerceMoneyValue(raw.dividendsPaid);

  if (!invested || !incomePaid || !incomeLeft || !incomeTotal || !dividendsPaid) {
    return null;
  }

  const forecastReturn = coerceMoneyValue(raw.forecastReturn) ?? undefined;

  return {
    packageUuid: raw.packageUuid,
    invested,
    incomePaid,
    incomeLeft,
    incomeTotal,
    dividendsPaid,
    roi: typeof raw.roi === 'number' ? raw.roi : undefined,
    xirr: typeof raw.xirr === 'number' ? raw.xirr : undefined,
    forecastReturn,
  };
}
